import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TPostContentBlockquoteSet, EPostContentBlockquoteActionType } from './types';
import { IPostContentBlockquote } from '../../types/postContentBlockquotes';

export const postContentBlockquoteSet: (data: IPostContentBlockquote) => TPostContentBlockquoteSet = actionGenerator<
  EPostContentBlockquoteActionType.Set,
  IPostContentBlockquote
>(EPostContentBlockquoteActionType.Set);
